import React from 'react';
import { setupIonicReact } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Home from './pages/Home';
import Login from './pages/Login';
import Registration from './pages/Registration';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

interface AppProps {
  isLoggedIn: boolean;
}

setupIonicReact();

const App = ({ isLoggedIn }: AppProps) => (
  <IonApp>
    <IonReactRouter>
      <IonRouterOutlet id="main">
        <Route path="/registration" component={Registration} exact={true} />
        <Route path="/login" component={Login} exact={true} />
        <Route path="/home" component={Home} />
        <Route
          exact
          path="/"
          render={() => {
            if (isLoggedIn) {
              return <Redirect to="/home" />;
            }
            return <Redirect to="/login" />;
          }}
        />
      </IonRouterOutlet>
    </IonReactRouter>
  </IonApp>
);

export default App;
